<template>
  <div id="app" :class="{ 'has-location': showLocation }">
    <header v-if="showLocation" class="location-status">未获取定位</header>
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  computed: {
    showLocation() {
      return [
        "/certification",
        "/trialByInstallments",
        "/consumptionVoucher",
        "/infomation",
        "/imageUpload",
      ].includes(this.$route.path);
    },
  },
};
</script>

<style lang="scss" scoped>
.location-status {
  height: 28px;
  background: #d4d4d4;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  line-height: 28px;
  text-align: center;
}
.has-location > main {
  min-height: calc(100vh - 28px);
}
</style>
